import { render, staticRenderFns } from "./JsrybgEdit.vue?vue&type=template&id=5c301ee2"
import script from "./JsrybgEdit.vue?vue&type=script&lang=js"
export * from "./JsrybgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports